module.exports = __webpack_public_path__ + "img/011.363cda8c.jpg";